module.exports = __webpack_public_path__ + "fonts/0e9d35e655b4e8e2c3db99c1e2d27237.svg";